import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueChartkick from 'vue-chartkick';
import VueLodash from 'vue-lodash';
import VueMaterial from 'vue-material';
import Vuelidate from 'vuelidate';
import {sync} from 'vuex-router-sync';
import ProgressBar from 'vuejs-progress-bar';

import App from './App';
import router from './router';
import store from './store';

import Chartkick from 'chartkick';
import lodash from 'lodash';

import './scss/styles.scss';
import 'vue-material/dist/vue-material.min.css';

import axios from 'axios';

import AsyncComputed from 'vue-async-computed';

import VModal from 'vue-js-modal';
import VueCookies from 'vue-cookies';
import VueHtmlToPaper from 'vue-html-to-paper';
import Datepicker from 'vuejs-datepicker';
import VueMoment from 'vue-moment';
// import moment from 'moment-timezone';
import Loading from 'vue-loading-overlay';
import VueEventBus from 'vue-event-bus';
import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);
Vue.use(Loading);
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
};
Vue.use(VueHtmlToPaper, options);
Vue.use(Datepicker);
Vue.use(VueMoment);
// Vue.use(moment);
Vue.use(VueHtmlToPaper);
Vue.use(VueEventBus);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(ProgressBar);
Vue.use(Chartkick);
Vue.use(VueChartkick, {Chartkick: Chartkick});
Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.use(VueLodash, lodash);

Vue.use(AsyncComputed);
Vue.use(VModal, {dynamicDefaults: {clickToClose: false}});

Vue.use(VueGoogleMaps, {
  load: {
    libraries: ['geometry', 'places'],
    key: 'AIzaSyBtb6N--ABCYTQ4iE1kVTKKU6-yEQPF7x4'
  }
});

sync(store, router, {moduleName: 'RouterModule'}); // syncs the vue-router to the Vuex store, accessible through this.$store.state.route

axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    router.push('/401');
  } else if (error.response.status === 403) {
    router.push('/403');
  }
  throw error;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js